import enLocal from 'vant/lib/locale/lang/en-US'
import ptJame from './languageJame/pt'
import ptGaea from './languageGaea/pt'
import ptAllen from './languageAllen/pt'
const pt = {
    300000: 'New Year Gifts',
    300001: '2022 New Year Gifts',
    300002: 'SuperEx will spend the New Year with you!',
    300003: 'Dear SuperEx users:<br>To celebrate the grand launch of SuperEx on the occasion of the New Year<br>we will randomly send out New Year gift packages worth 1,000,000 USDT by Airdrop.<br>Specific details of the activity are as follows:',
    300004: 'Time: <br>From 2022.01.01 00:00 ET To 2022.02.15 23:59 ET',
    300005: 'Activity 1: Share the activity poster and get Airdrop',
    300006: 'Share the event poster to Telegram cryptocurrency groups with no less than 1000 people, and add a note "Spend the New Year with SuperEx and start 2022 with a million dollar gift!" Or On your personal Twitter account, share the event poster with the words "Millions dollar gift is waiting for you. SuperEx will spend the New Year with you!" . Pin the tweet on your feed and upload a screenshot of the post to customer service and you will have a chance to get 5 ET (worth 5 USDT).',
    300007: 'Activity 2: Inviting new VIP members',
    300008: 'During the activity, the number of valid invitations is the number of users who have successfully registered from a friend\'s invitation and successfully deposited more than 100 USDT. Higher the number of successful invitations, higher the VIP level a user can obtain. The activity is valid for - 30 days. ',
    300009: 'Activity 3: New users can deposit and get ET rewards',
    300010: 'During the event, newly registered users will receive ET rewards when their net deposit amount reaches a certain range from the table below and completes a transaction.',
    300011: 'Precautions:',
    300012: '1.Each participating user can receive rewards only once.<br>2.All participating users abide by the SuperEx Terms of Service by default, and will immediately be unqualified from the even if any violations are found.<br>3.SuperEx reserves the right to modify terms of this event without notifying users in advance. <br>4.SuperEx will cancel the eligibility for non-compliant users to participate in the event and disable the use of related SuperEx accounts. <br>5.SuperEx reserves the right of final interpretation of this event.',
    300013: 'Get it now',
    300014: 'SuperEx Team',
    300015: '2022.01.01',
    300016: 'Follow SuperEx official website: SuperEx.com to learn more',
    300017: 'Net Deposit（{coin}）',
    300018: 'Bonus（{coin}）',
    300019: 'For 180 days',
    300020: 'Net deposit = Total deposit amount-Total withdrawal amount',
    300021: 'ET holdings',
    300022: 'Maker/Taker',
    300023: 'Valid invitations',
    300024: 'Gift validity',
    300025: 'Activity  conditions',
    300026: 'Note: All complimentary VIP levels do not require ET holdings.',

// 以上翻译没有，直接用英文


  300027: 'Cópia bem-sucedida',
  300028: 'Cópia falhou',
  300029: 'Baixar SuperEx APP',
  300030: 'Negocie a qualquer hora, em qualquer lugar',
  300031: 'Criar Conta SuperEx',
  300032: '若您已有SuperEx账户，请先登录',
  300033: 'Email',
  300034: 'Celular',
  300035: 'Número de telefone',
  300036: 'Senha',
  300037: 'ID do Referido (Opcional)',
  300038: 'Li e concordo com',
  300039: 'Termos de Serviço da SuperEx',
  300040: 'Estou com mais de 18 anos e concordo com os Termos da SuperEx.',
  300041: 'Registrar',
  300042: 'Verificação de Segurança',
  300043: 'Selecionar código de área',
  300044: 'Pesquisar',
  300045: 'Por favor, insira seu número de celular',
  300046: 'Por favor, insira um número de celular correto.',
  300047: 'Por favor, insira seu endereço de e-mail',
  300048: 'Por favor, insira um endereço de e-mail válido.',
  300049: 'Por favor, insira sua senha',
  300050: 'Pelo menos 8 caracteres, incluindo letras maiúsculas e números.',
  300051: 'Código de verificação de e-mail',
  300052: 'Código de verificação via SMS',
  300053: 'Verificação Google',
  300054: 'Google',
  300055: 'Para a segurança da sua conta, conclua as seguintes operações de verificação.',
  300056: 'Enviar',
  300057: 'Código de 6 dígitos será enviado para{phone}',
  300058: 'Código será enviado para{email}',
  300059: 'Insira o código de verificação de 6 dígitos do SuperEx/Google/Microsoft  ',
  // 300060: 'Digite o código de verificação de 6 dígitos',
  300060: 'Insira o código de 6 dígitos',
  300061: 'Enviar código',
  300062: 'Reenviar em {timeout}s',
  300063: 'Idioma',
  300064: 'Em avaliação',
  300065: 'Digite letras em inglês ou sinais de pontuação comuns.',


  300066: 'Centro de Tarefas',
  300067: 'Batalha de Classificação de Reembolso',
  300068: 'Reclame até <em class="bold normal" style="font-size: 1.2rem;color: #FFC72B;">1BTC</em>！',
  300069: 'Convidar',
  300070: 'Classificação',
  300071: 'Regras de Desbloqueio',
  300072: 'Receba mais ET',
  300073: 'Batalha de classificação de reembolso. Até 1 BTC te espera!',
  300074: 'Complete a transação para desbloquear ET',
  300075: '*Complete todas as tarefas acima para ser incluído na lista branca, e a SuperEx aleatoriamente distribuirá grandes quantidades de tokens ET para os usuários da lista branca ocasionalmente.',
  300076: 'Ranking Diário',
  300077: 'Ranking Total',
  300078: 'Termos de Serviço da',
  300079: 'Minhas recompensas',

  300080: 'Quantidade bloqueada',
  300081: 'Quantidade desbloqueada',
  300082: 'Valor de desbloqueio = taxa de transação * dificuldade de desbloqueio / preço ET  ',
  300083: 'Ir para o trading',
  300084: 'Classificação',
  300085: 'Conta',
  300086: 'Comissão',
  300087: 'Nota: A classificação diária é calculada até 0:00 do dia (UTC-4) e as recompensas serão emitidas no dia seguinte. Os dados podem conter erros e são para referência apenas.',
  300088: 'Nota: As recompensas serão emitidas dentro de 3 dias úteis após o término do evento, e os dados podem conter erros, servindo apenas como referência.',
  300089: 'Ver Mais',

  300090: 'Fechar',
  300091: 'Você já é um usuário na lista branca!',
  300092: 'Digite sua conta do {type}',
  300093: 'Preencha as informações',
  300094: 'Siga-nos no Twitter',
  300095: 'Junte-se ao nosso grupo oficial no Telegram.',
  300096: 'Realizar depósito agora',
  300097: 'Negociar à Vista',
  300098: 'Realizar a primeira negociação de contratos',
  300099: 'Recomende um amigo para se juntar agora',

  300100: 'Convide um amigo para negociar',
  300101: 'Recomende um amigo para negociar mais',
  300102: 'Depositar',
  300103: 'Seguir',
  300104: 'Reclamar',
  300105: 'Coletado (vezes)',
  300106: 'Ainda não aberto',
  300107: 'Junte-se',
  300108: 'Nenhum registro encontrado',
  300109: 'Concluído',
  300110: 'Convide amigos e ganhe mais SCS.',
  300111: 'Cancelar',
  300112: 'Enviar',
  300113: 'Não reenvie',
  300114: 'Atualmente, não há tarefas.',
  300115: 'Fique atento para mais tarefas',
  300116: 'Fique atento para mais eventos!',
  300117: 'Vincule sua conta do Twitter para receber.',
  300118: 'Vincule sua conta Telegram para receber.',
  300119: 'Desistir',
  300120: 'Registro Instantâneo no SuperEx',
  300121: 'Registrar-se',
  300122: 'Expirado',
  300123: 'Livro Branco',

  300124: 'Recompensa Caixa Mistério',
  300125: 'Abra a Caixa Misteriosa com seus amigos com <em class="normal bold" style="color: #FFC72B">100%</em> ，de chance de ganhar.',
  300126: 'Regras',

  300127: 'Abrir Caixa Misteriosa',
  300128: 'Número de sorteios',
  300129: 'Restante (meu)',
  300130: 'Aberto (Total USDT)',
  300131: 'Recompensas',
  300132: 'Como participar',
  300133: 'Compartilhe seu link de convite',
  300134: 'Completar tarefas',
  300135: 'Convide seus amigos a se registrar e completar tarefas de trading.',
  300136: 'Receber Caixa Misteriosa',

  300137: 'Complete tarefas e ganhe a Caixa Misteriosa',
  300138: 'Este evento terminou, aguarde o próximo!',
  300139: 'Este evento ainda não começou, fique atento!',
  300140: 'Regras do Evento',
  300141: 'OK',
  300142: 'Tempo',
  300143: 'Consultar',
  300144: 'Verificação de E-mail',
  300145: 'Convidar Amigos',
  300146: 'Acenda as abóboras e divirta-se com o <em class="normal" style="color: #FFC72B">Halloween</em>',
  300147: 'Assine por <em class="normal" style="color: #FFC72B">{num}</em> dias ，consecutivos e tenha a chance de ganhar o prêmio <em class="normal" style="color: #FFC72B">{amount} ET</em>',
  300148: 'Lista de vencedores',
  300149: 'Assinatura diária',

  300150: 'Você registrou {num} dias',
  300151: 'Sorteio de Prêmios',
  300152: 'Conectado',
  300153: 'Registro',
  300154: '',
  300155: '',
  300156: 'Assinar',
  300157: 'Recebeu um cupom de desconto na taxa de contrato',
  300158: 'VIP atualizado com sucesso',
  300159: 'Ganhe uma chance de ganhar na loteria！',

  300160: 'Voucher de Taxa de Contrato',
  300161: 'Upgrade VIP',
  300162: '',
  300163: 'Você tem <em class="normal" style="color: #FFC72B">{num}</em> oportunidades de re-assinatura.',
  300164: 'Obtenha uma chance de assinar',
  300165: 'Pode reassinar',
  300166: 'Dicas',
  300167: 'Assinatura refeito com sucesso',
  300168: 'Você ainda não tem quantidades de assinaturas. Um depósito líquido de ≥ {num} {symbol} no mesmo dia lhe dará 1 chance de re-assinatura.',
  300169: 'Iniciar sessão',

  300170: 'Você atingiu o limite de re-assinatura.',
  300171: 'Lista de vencedores dos usuários que assinaram durante 7 dias consecutivos.',
  300172: 'Assine continuamente para obter as seguintes recompensas.',
  300173: 'Reclamado',
  300174: '{num} Dia',
  300175: 'Vale de desconto',
  300176: 'Meu Nível VIP',
  300177: 'Participar do sorteio',
  300178: 'Parabéns!',
  300179: 'Check-in bem-sucedido',
  300180: '',
  300181: 'Academia',
  300182: 'Notícias',
  300183: 'Dados',
  300184: 'Academia',
  300185: 'Aprofunde-se nos principais eventos da indústria global de criptomoedas.',
  300186: 'Obtenha uma visão rápida dos últimos eventos na indústria de criptomoedas em todo o mundo.',
  300187: 'Aprenda tudo sobre blockchain, Web3 e criptomoeda.',
  300188: 'Leia mais',
  300189: 'Vídeos',
  300190: 'Carregando',
  300191: 'Tudo carregado',
  300192: 'Tudo',
  300193: 'Torneio Não Iniciado',
  300194: 'Preveja o campeão dos jogos da Copa e ganhe<em class="normal" style="color: #DBFF00">recompensas</em>',
  300195: 'Hora do Evento',
  300196: 'Registro de Votação',
  300197: 'Fase de Grupos',
  300198: '{num}Grupo ',
  300199: 'Fundo de Prêmios: {num}',
  300200: 'Apoio',
  300201: 'Fase Eliminatória',
  300202: 'Promoção',
  300203: 'Prazo para votar',
  300204: 'Votar',
  300205: 'Por favor, insira o número de votos',
  300206: 'Quantidade mínima de apostas: {num} ET',
  300207: 'Hora da Previsão',
  300208: 'Apostando em times',
  300209: 'Votos',
  300210: 'Valor do prêmio',
  300211: 'Equipas Qualificadas',
  300212: 'Dia',
  300213: 'H',
  300214: 'M',
  300215: 'S',
  300216: 'Partidas',
  300217: 'Evento ainda não começou',
  300218: '1/4Final',
  300219: 'Confirmar',
  300220: 'Número de votos',
  300221: 'Saldo insuficiente',
  300222: 'Depositar',
  300223: 'Previsão bem-sucedida',
  300224: '1/8Final',
  300225: 'Semi-final',
  300226: 'Finalistas do terceiro e quarto lugar',
  300227: 'Final',
  300228: 'Vencer',
  300229: 'Perda',
  300230: 'Total do Prêmio：{num} ET',
  300231: 'Ver Mais Partidas',
  300232: 'Outras Competições',
  300233: 'Moeda',
  300234: 'Preço Atual',
  300235: 'Variação 24h',
  300236: 'Guia para Novos Usuários',
  300237: 'Comece a aprender sobre negociações de moedas digitais agora.',
  300238: 'Presença Global',
  300239: 'Sem fronteiras, descentralização e autonomia comunitária, descentralização da equipe é a forma definitiva de desenvolvimento da SuperEx.',

  300240: 'Risco de segurança zero',
  300241: 'SuperWallet descentralizado integrado, e a chave privada é criptografada e armazenada no dispositivo do usuário. Não afetado por segurança de código, política e outros fatores.',
  300242: 'Sem registro e KYC ',
  300243: 'Transações autorizadas por carteira, sem registro, sem KYC, liquidações feitas na blockchain, imutáveis, seguras e transparentes.',
  300244: 'Sistema Aberto',
  300245: 'Permita que os usuários interajam com Dapps ou contratos inteligentes. Ao abrir o SuperWallet, os usuários podem participar autorizados em Meta, DeFi e NFTs.',
  300246: 'Fundo Espacial',
  300247: 'O Fundo Espacial é utilizado para a exploração humana do espaço ou para financiar instituições ou indivíduos que contribuíram significativamente para a exploração humana do espaço.',
  300248: 'Um mercado de criptomoedas seguro e fácil de usar',
  300249: 'Baixe o aplicativo móvel SuperEX para acompanhar os mercados e fazer negócios no momento perfeito, onde quer que esteja.',

  300250: 'Mais Opções de Download',
  300251: 'Cada transação que você faz ajuda a impulsionar a exploração de Marte e do universo.！',
  300252: 'Registre-se agora',
  300253: 'iOS e Android<br>Escaneie para Baixar',
  300254: 'Autenticador',
  300255: 'O autenticador gerará um código de verificação em 2 etapas para você. Mantenha sua conta SuperEx ainda mais segura com a verificação em 2 etapas.',
  300256: 'SuperEx Autenticador',
  300257: 'Autenticação Google',
  300258: 'Autenticador Microsoft',
  300259: 'Baixar cliente(iPhone)',

  300260: 'Baixar cliente(Android)',
  300261: 'A plataforma de negociação de ativos digitais mais segura do mundo!',
  300262: 'Sobre nós',
  300263: 'Termos',
  300264: 'Privacidade',
  300265: 'Announcements',
  300266: 'Academia',
  300267: 'Centro de Iniciantes',
  300268: 'Negociação Spot',
  300269: 'Futuros',

  300270: 'FAQ',
  300271: 'Serviço',
  300272: 'Taxa',
  300273: 'Regras',
  300274: 'Aplicação de Listagem',
  300275: 'Recompensa',
  300276: 'Fale Conosco',
  300277: 'Centro de Ajuda',
  300278: 'Enviar Solicitação',
  300279: 'Contatos Comerciais',

  300280: 'Cooperação Institucional',
  300281: 'Mais',
  300282: 'Bem-vindo de volta!',
  300283: 'Esqueceu a senha?',
  300284: 'Ainda não tem uma conta?',
  300285: 'Vá ao APP ou ao computador para recuperar a senha.',
  300286: 'Entendi',

  300287: 'Confirmar',
  300288: 'A ser anunciado',
  300289: 'A reivindicar',

  300290: 'Já Participou',
  300291: 'Já Reembolsado',
  300292: 'Regras de Compra',
  300293: 'Compra <span>Produtos</span>',
  300294: 'Escolher e Comprar',
  300295: 'Aguardando Resultados',
  300296: 'Retirar o item',
  300297: 'Recarga',
  300298: 'Registro de Compras',
  300299: 'Lista de Itens',
  300300: 'Taxa de participação única',
  300301: '{num} cópias foram vendidas. O item será vendido após alcançar {price} {currency}.',
  300302: 'Compre Agora',
  300303: 'Continuar Comprando',
  300304: 'Selecionar número de cópias para comprar',
  300305: "1 cópia requer <span class='span'>{minPrice} {currency}</span>, e cada item pode ser comprado no máximo",
  300306: 'cópias',
  300307: 'Você tem {num}{currency}, quanto mais cópias comprar, maior a chance de adquirir!',
  300308: 'Comprar',
  300309: 'Oportunidade perdida',
  // 300309: '余额充值',
  300310: 'Parabéns!',
  300311: 'Reclamar',
  300312: 'Tente novamente',
  300313: 'Complete o depósito de cripto ou P2P no APP.',
  // 300314: '我知道了',
  300315: 'Contact customer service on the app to claim the item.',
  // 300316: '我知道了',
  300317: 'Conectar-se ou Registrar-se',
  300318: 'Custo de{num} {currency}',
  300319: 'Descrição do item',
  300320: 'Minha participação',
  300321: 'Tempo',
  300322: 'Itens Participantes',
  300323: 'Número de cópias compradas',
  300324: 'Valor do reembolso',
  300325: 'Operação',
  300326: 'Reclamar',
  300327: 'Já tem uma conta?',
  300328: 'Entrar',
  300329: 'Código de autenticação',
  300330: 'Apenas os registros dos últimos sete dias são exibidos.',
  300331:'Autenticador',
  300332:'Baixar',
  300333:'1 USDT for 1 Bitcoin！',
  300334:"Preço de Compra",
  300335:"Resultados Anteriores",
  // 300336:"期次",
  300337:"Ver Regras",
  300338:"Edição:【Fase {num}】",
  300339:"Processo de Compra",
  300340:"Usuários Comprados com Sucesso",
  300341:"Hora do Anúncio",
  300342:"Compartilhar",
  300343:"Edição [{num}]",
  300345:"Baixar",
  300346:"Compartilhe sua alegria",
  300347:"Escanear código para participar",
  300348:"Retirar o item",
  300349:"Nota: Os itens de moeda digital serão enviados para sua conta em até 48 horas.",
  300350:"Contact customer service to claim other items",
  300351:"Ir para ver",
  300352:"Inscreva-se agora",
  300353:"Registrado",
  300354:'Inscrições encerradas',
  300355:'Inscrição bem-sucedida',
  300356:'Abrir o App',
  300357:'Parabéns a {user} por ganhar {shop}!',
  300358:'Centro de Eventos',
  300359:'Em Andamento',
  300360:'Iniciando em breve',
  300361:'Encerrado',
  300362:'Participe agora',
  300363: 'Encerrado',
  300364: 'Vencedores',
  300365: 'Os vencedores serão anunciados em breve',

  310000:'Visão Geral de Recompensas',
  310001:'Airdrop SCS',

  300366: 'Moeda',
  300367: 'Vender',
  200368: 'Pagar',
  300369: 'Receber',
  300370: 'Obter',
  300371: 'Limite de pagamento único:',
  300372: 'Forma de pagamento',
  300373: 'Método de recebimento',
  300374: 'Canal de pagamento',
  300375: 'Detalhes do pedido',
  300376: 'Montante (incluindo taxas de transação)',
  300377: 'Hora de chegada',
  300378: 'Isenção de Responsabilidade',
  300379: 'Li e concordo com o aviso de isenção',
  300380: "Você sairá do SuperEx e será redirecionado para <span>{name}</span>, uma instituição financeira licenciada que fornece capacidades de pagamento por cartão como terceiro. Quaisquer eventos de risco que ocorrerem durante o uso serão responsabilidade de <span>{name}</span>. Antes de usar os serviços de <span>{name}</span>, leia e concorde com o <a class='pointer' href={server}>Acordo de Serviço</a> dele. Se você tiver alguma dúvida sobre o depósito do cartão de crédito, entre em contato com o <a class='pointer' href={Customer}>{name}Atendimento ao Cliente do</a>para mais detalhes.",
  300381: 'Como comprar cripto na SuperEx?',
  300382: 'Como Vender Criptomoeda no SuperEx？',
  300383: 'Faça seu pedido de cripto',
  300384: 'Escolha a moeda fiduciária que deseja usar e a criptomoeda que quer comprar. Insira o valor que deseja gastar.',
  300385: 'Verifique sua identidade',
  300386: 'Complete a verificação KYC no SuperEx e no provedor de pagamentos para finalizar o pagamento.',
  300387: 'Verifique os detalhes do seu pedido',
  300388: 'Verifique seu histórico de depósitos para ver o status do seu pedido.',
  300389: 'FAQ',
  300390: '1. Quais métodos de pagamento posso usar para comprar criptomoeda?',
  300391: 'A SuperEx atualmente suporta vários métodos de pagamento, incluindo VISA, Mastercard, Apple Pay e Google Pay. Os provedores de serviços de terceiros suportados incluem Mercuryo e alchemypay.',
  300392: '2. Quais criptomoedas posso comprar?',
  300393: 'O SuperEx suporta criptomoedas populares como BTC, ETH, USDT, LTC, USDC, XRP, BCH, CRV e TRX.',
  300394: '3. A SuperEx monitora a qualidade e os preços dos provedores de serviços de terceiros suportados?',
  300395: 'A SuperEx selecionou cuidadosamente uma série de prestadores de serviços com boa reputação, popularidade e segurança no setor, para oferecer aos usuários serviços processuais.',
  300396: '4. Quais taxas preciso pagar para comprar criptomoeda?',
  300397: 'Você paga uma taxa ao provedor de serviços terceirizado e uma taxa de transferência on-chain. A SuperEx não cobra taxas.',
  300398: '5. Quanto tempo leva para receber a criptomoeda após o pagamento?',
  300399: 'Após a conclusão do pagamento na plataforma do prestador de serviços de terceiros, sua criptomoeda será depositada na sua conta à vista na SuperEx em cerca de 2 a 10 minutos.',
  300400: '6. O que fazer se eu encontrar problemas durante a compra?',
  300401: 'Entre em contato com o suporte ao cliente se você encontrar algum problema durante o processo de transação. Se você não recebeu a criptomoeda após o pagamento ser concluído, entre em contato com o prestador de serviços de terceiros para verificar os detalhes do pedido (geralmente este é o método mais eficiente). Devido ao IP da sua região atual ou a certas razões de política, você terá que escolher a verificação humana.',
  300402: "Disponível",
  300403: 'Saldo insuficiente',
  300404: 'Digite a moeda',
  300405: 'Digite a moeda fiduciária',
  300406: 'Você não concluiu a verificação de identidade.',
  300407: "Para a segurança da sua conta com outros usuários de negociação, por favor, complete primeiro a verificação de identidade.",
  300408: 'Verificar conta',
  300409: 'Não verificado',
  300410: 'Escolha uma moeda',
  300411: 'Selecionar moeda fiduciária',
  300412: 'Todas as moedas',
  300413: 'Todas as moedas fiduciárias',
  300414: '≈{time}minutos',
  300415: 'Negociação P2P não está disponível para usuários de carteira autorizados neste momento. Faça login com sua conta SuperEx para realizar negociações P2P.',
  300416: 'https://support.superex.com/hc/en-001/articles/23084120565017',
  300417: 'Comprar',
  300418: 'Número de Série',
  300419: 'SuperEx Halloween Carnaval',
  300420: 'Inscreva-se para desfrutar, o negócio ganha prêmios！',
  300421:'Tipo',
  300422:'Recompensas em Criptomoedas',
  300423:'',
  300424:'',

  400000:'Primeira Exchange de Cripto Web3',
  400001:'Junte-se a nós para criar um mundo financeiro.',
  400002:'Cada transação que você faz ajuda a impulsionar a exploração de Marte e do universo.',
  400003:'SuperEX Momentos Empolgantes',
  400004:'Cada momento brilhante é um testemunho de nossos passos e a força para avançar.',
  400005:'Selecionar idioma e região',
  400006:'0 RISCO',
  400007:'Sem KYC',
  400008:'aberto',
  400009:'fundo',
  400010:'Explorador da Mainnet',
  400011:'Explorador Testnet',
  400012:'Documentação do desenvolvedor',
  400013:'Outros',
  400014:'Zona ET',
  400015:'Canal de venda',

  400017: 'Insira o número de celular de 11 dígitos',

  ...enLocal,
  ...ptJame,
  ...ptGaea,
  ...ptAllen
}
export default pt;



// WEBPACK FOOTER //
// ./src/i18n/langs/pt.js